import { Space, Typography } from 'antd';
import 'moment/locale/vi';
import React from 'react';

const RelatedUser = ({ creator, updater, approver, broadcastChecker, broadcastApprover }) => {
  return (
    <Space direction="vertical">
      <Typography.Text>
        <Typography.Text strong>Khởi tạo: </Typography.Text>
        {creator?.name}
      </Typography.Text>

      <Typography.Text>
        <Typography.Text strong>Cập nhật: </Typography.Text>
        {updater?.name}
      </Typography.Text>

      {approver && (
        <Typography.Text>
          <Typography.Text strong>Duyệt nội dung: </Typography.Text>
          {approver?.name}
        </Typography.Text>
      )}

      {broadcastChecker && (
        <Typography.Text>
          <Typography.Text strong>Kiểm tra phát sóng: </Typography.Text>
          {broadcastChecker?.name}
        </Typography.Text>
      )}

      {broadcastApprover && (
        <Typography.Text>
          <Typography.Text strong>Duyệt phát sóng: </Typography.Text>
          {broadcastApprover?.name}
        </Typography.Text>
      )}
    </Space>
  );
};

export default RelatedUser;
